import styled from "styled-components";
import ResponsiveImg from "../ResponsiveImage";

const Wrapper = styled.div`
  width: 100%;
  max-width: 450px;
  height: 33rem;
  object-fit: contain;
  position: relative;
  transition: transform 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  /* Z-index: center slide on top, adjacent behind, others further back */
  z-index: ${(props) => (props.isActive ? "3" : props.isAdjacent ? "2" : "1")};

  /* Desktop scaling and sizing with translation */
  transform: ${(props) => {
    const scale = props.isActive
      ? "scale(1.2)"
      : props.isAdjacent
      ? "scale(0.90)"
      : "scale(0.75)";

    const translate = props.isPrev
      ? "translateX(-13%)"
      : props.isNext
      ? "translateX(13%)"
      : "translateX(0)";

    return `${scale} ${translate}`;
  }};

  @media (max-width: 768px) {
    max-width: 100% !important;
    height: 240px !important;

    transform: ${(props) =>
      props.isActive
        ? "scale(1.2)"
        : props.isAdjacent
        ? "scale(0.85)"
        : "scale(0.75)"};
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* border-radius: 8px; */
  }
`;

function HeaderSliderImg({
  img,
  isActive,
  isPrev,
  isNext,
  alt = "Destination photo",
  fetchpriority,
}) {
  const isAdjacent = isPrev || isNext;

  return (
    <Wrapper
      isActive={isActive}
      isAdjacent={isAdjacent}
      isPrev={isPrev}
      isNext={isNext}
    >
      <ResponsiveImg
        src={img}
        alt={alt}
        sizes="(max-width: 768px) 300px, 540px"
        fetchpriority={fetchpriority}
      />
    </Wrapper>
  );
}

export default HeaderSliderImg;
